import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import { Grid, CircularProgress } from '@material-ui/core'
import getIdFromSlug from '../../../utils/getIDfromSlug'
import EnrollmentEdit from './EnrollmentEdit'
import Contacts from '../Summary/Contacts'
import ErrorMessage from '../../../components/ErrorMessage'

const GET_ENROLLMENT = gql`
  query($id: ID!) {
    enrollment(id: $id) {
      id
      types
      status
      project {
        id
        title
      }
      estStudentCount
      estTeacherCount
      comments
      school {
        id
        name
      }
      contacts {
        id
        slug
        firstName
        lastName
        fullName
        phoneNumber
        email
        type
      }
    }
  }
`

const Edit = props => {
  const { slug } = props
  const id = getIdFromSlug(slug)
  const { data, loading, error, refetch } = useQuery(GET_ENROLLMENT, { variables: { id: id } })

  if (loading) return <CircularProgress color="secondary" />
  if (error) return <ErrorMessage>{error.message}</ErrorMessage>

  return (
    <Grid container spacing={3}>
      <Grid item lg={7} md={6} xl={3} xs={12}>
        <EnrollmentEdit enrollment={data.enrollment} refetch={refetch} />
      </Grid>
      <Grid item lg={5} md={6} xl={6} xs={12}>
        <Contacts
          contacts={data.enrollment.contacts}
          enrollmentID={data.enrollment.id}
          refetch={refetch}
          slug={slug}
        />
      </Grid>
    </Grid>
  )
}

Edit.propTypes = {
  slug: PropTypes.string,
}

export default Edit
